import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';

import { rootReducer } from './../modules';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from "redux-persist/lib/storage/session";

const persistConfig = {
    key: "root",
    storage: storageSession,
    whitelist: ["user"], // Add reducers that should be persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

export { store, persistor };
